import * as types from './annuals.types';
import * as constants from './annuals.constants';
import { IAnnual } from '../../resource/annuals/annuals.types';

export const createAnnual = (annual: types.ICreateAnnualPayload): types.ICreateAnnualAction => ({
  type: constants.CREATE_ANNUAL,
  payload: annual,
});

export const updateAnnual = (
  annualId: IAnnual['id'],
  annual: types.ICreateAnnualPayload,
): types.IUpdateAnnualAction => ({
  type: constants.UPDATE_ANNUAL,
  payload: { annualId, payload: annual },
});

export const deleteAnnual = (annualId: IAnnual['id']): types.IDeleteAnnualAction => ({
  type: constants.DELETE_ANNUAL,
  payload: { annualId },
});
